import React, { useEffect, useState } from "react";
import { Form, Image } from "react-bootstrap";

interface FileInputProps {
  label: string;
  name: string;
  multiple?: boolean;
  existing?: string | string[] | null;
  onChange: (name: string, files: FileList | null) => void;
}

const FileInput: React.FC<FileInputProps> = ({
  label,
  name,
  multiple = false,
  existing = null,
  onChange,
}) => {
  const [previews, setPreviews] = useState<string[]>([]);

  useEffect(() => {
    if (existing) {
      setPreviews(Array.isArray(existing) ? existing : [existing]);
    }
  }, [existing]);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const urls = Array.from(files).map((file) => URL.createObjectURL(file));
      setPreviews(urls);
      onChange(name, files);
    }
  };

  return (
    <Form.Group className="mb-3">
      <label>{label}</label>
      <Form.Control
        type="file"
        name={name}
        multiple={multiple}
        accept="image/*"
        onChange={handleFileChange}
      />
      <div className="d-flex flex-wrap gap-2 mt-2">
        {previews.map((src, i) => (
          <Image
            key={i}
            src={src}
            alt="preview"
            width={100}
            height={100}
            thumbnail
          />
        ))}
      </div>
    </Form.Group>
  );
};

export default FileInput;
